import React, {Component ,Fragment} from 'react';
import {compose} from 'redux';
import { connect } from "react-redux";
import {Formik } from 'formik';

import {Grid} from '@material-ui/core';
import _ from 'lodash'
import moment from 'moment';
import styled from 'styled-components';

import { calculateLoanProceeds,downloadLoanProceeds } from "store/state/calculators/testHarness";

import {getDealPropertyProjections } from "store/state/deal";
import {getLoanProceedAssumptions, getLoanProceedAssumptionsByDealId} from 'store/state/loan/loan';

import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';

import { PARALLEL_SHOCK, MARKET_EXPECTATIONS_SHOCK, TREASURIES } from "../../Constants/Constants";
import {getConfigItemByParentId} from 'store/state/configItems';
import {INTEREST_RATE_TYPE, FLOATING_INDICES, FIXED_INDICES} from "constants/configItemParents";
import { setConfigItemListState } from "components/Global/Fields/util";

import AssetAssumptionsSection from "./AssetAssumptionsSection";
import LoanAssumptionsSection from "./LoanAssumptionsSection";
import ConstraintsSection from "./ConstraintsSection";
import RateEnvironmentSection from "./RateEnvironmentSection";
import { ModalButtonBar, StyledDatePicker, ParentGridContainer, ResultsGridContainer} from '../styles';
import AnalysisResult from './AnalysisResult';


class LoanProceedsModal extends Component {
    state = {
      interestRateTypes: [],
      floatingIndices: [],
      fixedIndices: [],
      formikKey: 0, 
      shouldRefreshAssumptions: true,
    }

    componentDidMount() {
      this.props.getLoanProceedAssumptionsByDealId({dealId: this.props.dealId});
      this.props.getDealPropertyProjections({dealId: this.props.dealId});

      this.props.getLoanProceedAssumptions();
      this.props.getConfigItemByParentId({ id: INTEREST_RATE_TYPE });
      this.props.getConfigItemByParentId({ id: FLOATING_INDICES });
      this.props.getConfigItemByParentId({ id: FIXED_INDICES });
     }

    componentDidUpdate(prevProps) {      
      if (this.props.configItems && this.props.configItems.configItemByParent) {
        setConfigItemListState(INTEREST_RATE_TYPE, "interestRateTypes", this);
        setConfigItemListState(FLOATING_INDICES, "floatingIndices", this);
        setConfigItemListState(FIXED_INDICES, "fixedIndices", this);
      }
      if(this.props.loanProceedAssumptionsForDeal != prevProps.loanProceedAssumptionsForDeal ){
        this.setState({shouldRefreshAssumptions: true});
      }
    }


    createLoanProceedsRequestParameters = (values) => {
      this.setState({shouldRefreshAssumptions: false});
      const {
        UwRate,
        amortizationTerm,
        debtYield,
        dscr,
        futureCapRate,
        interestRateType,
        rateIndex,
        loanTerm,
        loanType,
        maxLTV,
        projectedNOI,
        shockType,
        shockValue,
        spread,
      } = values;
      
      
      const loanProceedsRequestParameters = {};
        loanProceedsRequestParameters.subKey = this.props.dealId;

        loanProceedsRequestParameters.calculationDate = moment(values.calculationDate).format("YYYY-MM-DD");
        
        loanProceedsRequestParameters.shockType = !shockType ? MARKET_EXPECTATIONS_SHOCK : shockType;

        
        loanProceedsRequestParameters.shockValue = parseFloat(shockValue);
        
        if(shockType === PARALLEL_SHOCK && values.shockValue && values.shockValue !== 0) {
          const parallelValue = parseFloat(shockValue) * 0.0001;
          loanProceedsRequestParameters.shockValue = parallelValue;
        }
        
        if(shockType === MARKET_EXPECTATIONS_SHOCK)
          delete loanProceedsRequestParameters.shockValue;
        
        if(futureCapRate) loanProceedsRequestParameters.futureCapRate = this.transformRate(futureCapRate);
        loanProceedsRequestParameters.projectedNOI =  projectedNOI;
        
        loanProceedsRequestParameters.loanType =  loanType;
        loanProceedsRequestParameters.loanTerm =  loanTerm;
        loanProceedsRequestParameters.amortizationTerm =  amortizationTerm;
        if(spread) loanProceedsRequestParameters.spread = this.transformRate(spread);
        loanProceedsRequestParameters.interestRateType =  interestRateType;
        loanProceedsRequestParameters.rateIndex =  rateIndex;
        if(UwRate) loanProceedsRequestParameters.UwRate = this.transformRate(UwRate);
        
        if(debtYield) loanProceedsRequestParameters.debtYield = this.transformRate(debtYield);
        loanProceedsRequestParameters.dscr =  dscr;
        if(maxLTV) loanProceedsRequestParameters.maxLTV = this.transformRate(maxLTV);
      
      return loanProceedsRequestParameters;
    }


      transformRate = (val) => {
        return +val / 100;
      }
      handleDownload = (values) => {

        let request = this.createLoanProceedsRequestParameters(values);
        request.callback = () => {
            this.props.downloadLoanProceeds({dealId: this.props.dealId, assumptions: values, loanProceeds: this.props.loanProceeds});
        }
        
        this.props.calculateLoanProceeds(request);
      }

      setLoanProceedAssumptions = (selectedItem, formik) => {
        if(this.props.loanProceedAssumptions || this.props.loanProceedAssumptions.length > 0){
          const foundloanProceedAssumptions = _.find(this.props.loanProceedAssumptions,  { "loanType": selectedItem.value, },) || {};
          
          formik.values.loanType = foundloanProceedAssumptions.loanType;
          formik.values.loanTerm = foundloanProceedAssumptions.term ;
          formik.values.amortizationTerm = foundloanProceedAssumptions.amortization;
          formik.values.spread = foundloanProceedAssumptions.loanSpread ? foundloanProceedAssumptions.loanSpread : "";
          formik.values.interestRateType = foundloanProceedAssumptions.rateTypeId;
          formik.values.rateIndex = foundloanProceedAssumptions.indexId;
          formik.values.UwRate = foundloanProceedAssumptions.UwRate ? foundloanProceedAssumptions.UwRate : "";
          
          formik.values.debtYield = foundloanProceedAssumptions.minDebtYield ? foundloanProceedAssumptions.minDebtYield : "";
          formik.values.dscr = foundloanProceedAssumptions.minDSCR ? foundloanProceedAssumptions.minDSCR : "";
          formik.values.maxLTV = foundloanProceedAssumptions.maxLTV ? foundloanProceedAssumptions.maxLTV : "";
          this.forceUpdate();
        }
      }

      findProjectionValues = (calculationDate) => {
        const {dealPropertyProjections} = this.props;
        if(!calculationDate) calculationDate = moment();

        if(dealPropertyProjections.length > 0){
          const found = dealPropertyProjections.sort((a, b) => moment.utc(b.periodDate).unix() - moment.utc(a.periodDate).unix() )
          .find( x => {
            const periodDate = moment(x.periodDate);
            return periodDate<=calculationDate;
          });
          return found;
        }
      }

      setLoanProceedAssumptionsForDeal = (initialValues) => {
        if(this.props.loanProceedAssumptionsForDeal) {          
          if(this.props.loanProceedAssumptionsForDeal !== "Not Set"){
            const saved =  this.props.loanProceedAssumptionsForDeal;
  
            if(saved.loanType) initialValues.loanType   = saved.loanType;
            if(saved.term) initialValues.loanTerm   = saved.term;
            if(saved.amortization) initialValues.amortizationTerm   = saved.amortization;
            if(saved.loanSpread) initialValues.spread   = saved.loanSpread;
            if(saved.rateTypeId) initialValues.interestRateType   = saved.rateTypeId;
            if(saved.indexId) initialValues.rateIndex = saved.indexId;
            if(saved.UwRate) initialValues.UwRate   = saved.UwRate;
  
            if(saved.minDebtYield) initialValues.debtYield   = saved.minDebtYield;
            if(saved.minDSCR) initialValues.dscr   = saved.minDSCR ;
            if(saved.maxLTV) initialValues.maxLTV   = saved.maxLTV;
          }
          
        }
      }
      setProjectionValues = (initialValues) => {
        if(this.props.dealPropertyProjections) {
          const foundProjection = this.findProjectionValues();
          if(foundProjection){
            initialValues.projectedNOI = foundProjection.noi;
            initialValues.futureCapRate = foundProjection.capRate;
          }
        }
      }

      render(){
        if(!this.props.dealPropertyProjections || !this.props.loanProceedAssumptionsForDeal) return null;
        
        let initialValues =  {
            calculationDate: moment(),
            
            shockType: MARKET_EXPECTATIONS_SHOCK,
            shockValue: "",
            
            futureCapRate: "",
            projectedNOI: 0.0,
            
            loanType: "",
            loanTerm: "",
            amortizationTerm: "",
            spread: "",
            interestRateType: "",
            rateIndex: "",
            UwRate: "",
    
            debtYield: "",
            dscr: "",
            maxLTV: "",
          };
          
          if(this.state.shouldRefreshAssumptions){
            this.setProjectionValues(initialValues);
            this.setLoanProceedAssumptionsForDeal(initialValues);
            let request = this.createLoanProceedsRequestParameters(initialValues);
            this.props.calculateLoanProceeds(request);
          }
          
          
        return (
            <Formik 
            key={this.state.formikKey}
            initialValues={initialValues}
            enableReinitialize={this.state.shouldRefreshAssumptions}
            validate={values => { let errors ={};  return errors; }}
            onSubmit={(values,{setSubmitting}) => {   
              let request = this.createLoanProceedsRequestParameters(values);
              this.props.calculateLoanProceeds(request);
              setSubmitting(false);
            }}
            render={({values,errors,status,touched, isSubmitting,handleChange, handleBlur,handleSubmit}) => (
                <Fragment>

                  <Grid container item xs={12} spacing={8}  >
                  

                        <RateEnvironmentSection dealPropertyProjections={this.props.dealPropertyProjections} findProjectionValues={this.findProjectionValues}/>
                        
                        <ModalButtonBar item xs={3}>
                            <PrimaryButton onClick={handleSubmit}>Calculate</PrimaryButton>
                            <SecondaryButton onClick={() => this.handleDownload(values)}>PDF</SecondaryButton>
                        </ModalButtonBar>
                      
                  </Grid>
                  <ParentGridContainer>
                    <Grid container item xs={12}>
                      <Grid container item xs={3}>
                        <LoanAssumptionsSection setLoanProceedAssumptions={this.setLoanProceedAssumptions} interestRateTypes={this.state.interestRateTypes} floatingIndices={this.state.floatingIndices} fixedIndices={this.state.fixedIndices}/>
                      </Grid>
                      <Grid container item xs={3}>
                        <AssetAssumptionsSection/>
                        <ConstraintsSection/>
                      </Grid>
                      <Grid item xs={6}>
                        <ResultsGridContainer><AnalysisResult loanProceeds={this.props.loanProceeds}/></ResultsGridContainer>
                      </Grid>
                    </Grid>
                  </ParentGridContainer>
              </Fragment>
            )}/>
            
            );
          }
        }


function mapStateToProps({testHarness, loan, configItems, deal}, ownProps) {
  return {
          loanProceeds: testHarness.loanProceeds && testHarness.loanProceeds[ownProps.dealId] ? testHarness.loanProceeds[ownProps.dealId] : null,
          loanProceedAssumptions: loan.loanProceedAssumptions,
          configItems,
          dealPropertyProjections: ownProps.dealId && deal.dealPropertyProjections ? deal.dealPropertyProjections[ownProps.dealId] : null,
          loanProceedAssumptionsForDeal: ownProps.dealId && loan.loanProceedAssumptionsForDeal ? loan.loanProceedAssumptionsForDeal[ownProps.dealId] : null,
        }
}
  
export default compose(
  connect(
    mapStateToProps,
    {
      calculateLoanProceeds,
      downloadLoanProceeds,
      getLoanProceedAssumptions,
      getLoanProceedAssumptionsByDealId,
      getConfigItemByParentId,
      getDealPropertyProjections,
    }
    ))(LoanProceedsModal);
